/**
 * Service URLs - Local copy for Vite compatibility
 *
 * This file exists because Vite/Rollup has issues with CommonJS re-exports
 * from @ops-matrix/shared-types. This provides the same URLS but in ESM format.
 *
 * @see 1-shared-types/config/ports.json for canonical source
 */

// Import directly from shared-types config - this works with Vite
// because we're not going through the CommonJS index.js
import portsJson from '../../../1-shared-types/config/ports.json';

const { defaults, services } = portsJson;
const { host, httpProtocol } = defaults;

// Build URLs with proper types
export const DEFAULT_PORTAL_URLS = {
  ADMIN_PORTAL: `${httpProtocol}://${host}:${services.portals.ADMIN_PORTAL.port}`,
  BUSINESS_PORTAL: `${httpProtocol}://${host}:${services.portals.BUSINESS_PORTAL.port}`,
  CONSUMER_PORTAL: `${httpProtocol}://${host}:${services.portals.CONSUMER_PORTAL.port}`,
  AUTH_PORTAL: `${httpProtocol}://${host}:${services.portals.AUTH_PORTAL.port}`,
  API_GATEWAY: `${httpProtocol}://${host}:${services.http.API_GATEWAY.port}`,
} as const;

// Export PORTS for convenience
export const PORTS = {
  ADMIN_PORTAL: services.portals.ADMIN_PORTAL.port,
  BUSINESS_PORTAL: services.portals.BUSINESS_PORTAL.port,
  CONSUMER_PORTAL: services.portals.CONSUMER_PORTAL.port,
  AUTH_PORTAL: services.portals.AUTH_PORTAL.port,
  API_GATEWAY: services.http.API_GATEWAY.port,
} as const;

// Alias for backwards compatibility with code expecting URLS
export const URLS = DEFAULT_PORTAL_URLS;
